import React, { useContext } from 'react';
import {
  FlexColumn,
  FlexItem,
  FlexRow,
} from '@components/layout/FlexStyles';
import {
  TextRegular,
  TextSmall,
  TextTinyItalics,
} from '@components/elements/TextStyles';
import { UserContext } from '@stores/UserContext';
import {sciScoreCards} from '@app_config/home.cards';
import PageTiles from '@components/layout/PageTiles';

const OrdersSuccess = () => {
  const { user } = useContext(UserContext);

  return (
    <FlexColumn h_centered>
      <FlexRow height={'100px'}></FlexRow>
      <FlexItem>
        <TextRegular color={'accent'}>Thank you {user?.regInfo?.name?.first}. Your purchase of SciScore Credits has been successful.</TextRegular>
      </FlexItem>
      <FlexItem>
        <TextSmall color={'primary'}>An invoice has been sent to your email address.</TextSmall>
      </FlexItem>
      <FlexItem>
        <TextTinyItalics>It may take a moment or two for your credits to be updated.</TextTinyItalics>
      </FlexItem>
      <FlexItem>
        <TextSmall color={'primary'}>If your credits are shown as non-zero, please submit your methods and materials for analysis.</TextSmall>
      </FlexItem>
      <FlexRow h_centered>
        <PageTiles
          isAuthorized={true}
          cards = {[sciScoreCards[1]]}
        />
      </FlexRow>
    </FlexColumn>
  );
};

export default OrdersSuccess;
